var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElevenMusic20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "M8.332 15.417c0 1.15-1.12 2.083-2.5 2.083-1.381 0-2.5-.933-2.5-2.083s1.119-2.084 2.5-2.084c1.38 0 2.5.933 2.5 2.084Zm0 0V6.24c0-.736.482-1.385 1.187-1.596l5-1.5c1.07-.321 2.146.48 2.146 1.596v8.177m0 0c0 1.15-1.12 2.083-2.5 2.083s-2.5-.933-2.5-2.083 1.12-2.084 2.5-2.084 2.5.933 2.5 2.084Z"
})));
export default SvgElevenMusic20;